import { render, staticRenderFns } from "./DrawerStartGiftList.vue?vue&type=template&id=5f1d6da0&scoped=true&"
import script from "./DrawerStartGiftList.vue?vue&type=script&lang=js&"
export * from "./DrawerStartGiftList.vue?vue&type=script&lang=js&"
import style0 from "./DrawerStartGiftList.vue?vue&type=style&index=0&id=5f1d6da0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f1d6da0",
  null
  
)

export default component.exports